/* istanbul ignore file */
import NoAccess from './NoAccess';

export default NoAccess;
